/**
 * This is the entry point of the application.
 * It sets up the Firebase, creates the root ReactDOM, and renders the main App component.
 * The App component is wrapped with Redux Provider, ContextProvider, CustomMsalProvider, and CustomLoader.
 * It also registers the service worker and reports web vitals.
 */

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './app/App';
import CustomMsalProvider from './app/Components/CustomMsalProvider/CustomMsalProvider';
import CustomLoader from './app/Components/Shared/CustomLoader/CustomLoader';
import { ContextProvider } from './app/Context/AppContext';
import { initFirebase } from './app/Helpers/FirebaseHelper';
import { setupStore } from './app/Redux/Store';
import './i18n';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

initFirebase();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <CustomMsalProvider>
    <Provider store={setupStore()}>
      <ContextProvider>
        <App />
      </ContextProvider>
      <CustomLoader />
    </Provider>
  </CustomMsalProvider>,
);

serviceWorkerRegistration.register();

reportWebVitals();
